const GeeksforGeeksIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" fill="#0F9D58">
    <circle cx="512" cy="512" r="512" fill="#0F9D58" />
    <text x="50%" y="50%" fill="white" font-size="300" text-anchor="middle" dy=".35em" font-family="Arial, sans-serif">GFG</text>
  </svg>

);

export default GeeksforGeeksIcon;
